import { Maybe } from '@/utils/types'
import { TitleItemType } from '../types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'discover' | 'brand_landing' | 'player'

/**
 * Interaction builder for recommended titles in rails
 * Used for tracking user interactions with suggested/recommended content
 */
export class SuggestedRailItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<TitleItemType>; attribution: unknown }) {
    super(item)
  }
}
